<template>
 <div>
  <EchoLastData
       :dataList="orderPayPreview"
       :model="renderData.model.topPreviewModel"
     />
  <Success>
    <div slot="content">
      <div class="tip">签约提车流程已完成，您可在【租赁中】模块继续管理车辆订单</div>
      <div>
        <el-button @click="close">关闭</el-button>
        <el-button @click="continueBuild" >继续新建</el-button>
        <el-button @click="goPage" type="primary">前往租赁中订单列表</el-button>
      </div>
    </div>
  </Success>
 </div>
</template>

<script>
import Success from '../../../components/Success.vue'
import { orderPayPreview } from '../../config/echoLastData'
import EchoLastData from '../../../components/EchoLastData.vue'

export default {
  components: {
    Success,
    EchoLastData,
  },
  props: {
    renderData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      orderPayPreview,
    }
  },
  mounted() {
  },
  methods: {
    // 关闭
    close() {
      this.$refreshBack() // 关闭当前tab
      this.$router.push({
        path: '/car_to_lease/forRentSignContract',
        query: {
          activeName: 'child',
        },
      })
    },
    // 继续新建
    continueBuild() {
      this.$emit('continueBuild')
    },
    goPage() {
      this.$refreshBack() // 关闭当前tab
      // 跳租中-租赁中订单列表-企业租赁子订单
      this.$router.push({
        path: '/underLease/underLeaseOrder',
        query: {
          activeName: 'child',
        },
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.tip{
  margin: 30px;
  font-weight: bold;
}
</style>
